import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: 'bookings',
      method: 'get',
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `bookings/cancellation/status/${args.id}`,
      method: 'patch',
      params: args?.params,
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)

    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
export default { list, update }
